import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef, vModelText as _vModelText, mergeProps as _mergeProps, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, Transition as _Transition, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-8 flex justify-center items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "p-6"
}
const _hoisted_3 = {
  key: 2,
  class: "p-6 space-y-5"
}
const _hoisted_4 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 flex items-center gap-1"
}
const _hoisted_5 = { class: "mt-2 text-xs text-slate-500 text-right" }
const _hoisted_6 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 flex items-center gap-1"
}
const _hoisted_7 = { class: "mt-2 text-xs text-slate-500 text-right" }

import { watch, computed } from "vue";
import { useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/yup";
import * as yup from "yup";
import AdminModalShell from "@/share/components/admin/AdminModalShell.vue";
import AdminModalHeader from "@/share/components/admin/AdminModalHeader.vue";
import AdminModalFooter from "@/share/components/admin/AdminModalFooter.vue";
import AdminButton from "@/share/components/admin/AdminButton.vue";
import type { CategoriaCreateInterface } from "../../interfaces/categoriaInterfaces/CategoriaCreate.interface";
import { useCategoriaProductoFindOne } from "../../composables/categoriaComposables";

interface Props {
  isOpen: boolean;
  categoriaId?: string;
  isSaving?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FormularioCategoria',
  props: {
    isOpen: { type: Boolean },
    categoriaId: {},
    isSaving: { type: Boolean, default: false }
  },
  emits: ["close", "save", "update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const schema = toTypedSchema(
  yup.object({
    nombreCategoria: yup
      .string()
      .required("El nombre es obligatorio")
      .trim()
      .min(3, "El nombre debe tener al menos 3 caracteres")
      .max(50, "El nombre no puede exceder 50 caracteres")
      .matches(
        /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9\s]+$/,
        "El nombre solo puede contener letras, números y espacios"
      ),
    descripcionCategoria: yup
      .string()
      .default("")
      .max(200, "La descripción no puede exceder 200 caracteres"),
  })
);

const { defineField, errors, handleSubmit, resetForm, meta, setValues } =
  useForm({
    validationSchema: schema,
    initialValues: {
      nombreCategoria: "",
      descripcionCategoria: "",
    },
  });

const [nombreCategoria, nombreCategoriaAttrs] =
  defineField("nombreCategoria");
const [descripcionCategoria, descripcionCategoriaAttrs] = defineField(
  "descripcionCategoria"
);

const categoriaIdRef = computed(() => props.categoriaId || "");
const {
  data: categoriaData,
  isPending,
  isError,
} = useCategoriaProductoFindOne(categoriaIdRef);
const isEditMode = computed(() => !!props.categoriaId);

watch(
  categoriaData,
  (newData) => {
    const categoria = newData?.data?.data;

    if (
      categoria &&
      typeof categoria === "object" &&
      categoria.nombreCategoria
    ) {
      setValues({
        nombreCategoria: categoria.nombreCategoria || "",
        descripcionCategoria: categoria.descripcionCategoria || "",
      });
    }
  },
  { immediate: true, deep: true }
);

watch(
  () => props.isOpen,
  (isOpen) => {
    if (!isOpen && !isEditMode.value) {
      limpiarCampos();
    }
  }
);

const limpiarCampos = () => {
  resetForm({
    values: {
      nombreCategoria: "",
      descripcionCategoria: "",
    },
  });
};

const handleSave = handleSubmit((vals) => {
  const categoria: CategoriaCreateInterface = {
    nombreCategoria: vals.nombreCategoria.trim(),
    descripcionCategoria: (vals.descripcionCategoria || "").trim(),
  };

  if (isEditMode.value && props.categoriaId) {
    emit("update", props.categoriaId, categoria);
  } else {
    emit("save", categoria);
  }
});

const handleClose = () => {
  limpiarCampos();
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40 flex items-center justify-center p-4",
            onClick: _withModifiers(handleClose, ["self"])
          }, [
            _createVNode(_Transition, { name: "scale" }, {
              default: _withCtx(() => [
                (__props.isOpen)
                  ? (_openBlock(), _createBlock(AdminModalShell, { key: 0 }, {
                      header: _withCtx(() => [
                        _createVNode(AdminModalHeader, {
                          variant: "dark",
                          title: isEditMode.value ? 'Editar Categoría' : 'Nueva Categoría',
                          onClose: handleClose
                        }, {
                          icon: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("svg", {
                              class: "w-7 h-7",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                              })
                            ], -1)
                          ]))]),
                          _: 1
                        }, 8, ["title"])
                      ]),
                      footer: _withCtx(() => [
                        _createVNode(AdminModalFooter, { "rounded-bottom": "" }, {
                          default: _withCtx(() => [
                            _createVNode(AdminButton, {
                              variant: "secondary",
                              onClick: handleClose
                            }, {
                              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                _createTextVNode(" Cancelar ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(AdminButton, {
                              variant: "info",
                              disabled: !_unref(meta).valid || (_unref(isPending) && isEditMode.value) || props.isSaving,
                              loading: props.isSaving,
                              onClick: _unref(handleSave)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.isSaving
                    ? "Guardando…"
                    : isEditMode.value
                      ? "Actualizar"
                      : "Guardar"), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading", "onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_unref(isPending) && isEditMode.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[3] || (_cache[3] = [
                              _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-red-600" }, null, -1)
                            ]))]))
                          : (_unref(isError) && isEditMode.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[4] || (_cache[4] = [
                                _createElementVNode("div", { class: "bg-red-50 border-2 border-red-200 rounded-xl p-4 text-center" }, [
                                  _createElementVNode("p", { class: "text-red-600 font-semibold" }, " Error al cargar la categoría ")
                                ], -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("div", null, [
                                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "block text-sm font-semibold text-slate-700 mb-2" }, [
                                    _createTextVNode(" Nombre de Categoría "),
                                    _createElementVNode("span", { class: "text-red-500" }, "*")
                                  ], -1)),
                                  _withDirectives(_createElementVNode("input", _mergeProps({
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(nombreCategoria) ? (nombreCategoria).value = $event : null))
                                  }, _unref(nombreCategoriaAttrs), {
                                    type: "text",
                                    placeholder: "Ej: Electrónica, Ropa, Alimentos...",
                                    maxlength: "50",
                                    class: [
                  'w-full px-4 py-3 border-2 rounded-xl transition-all outline-none',
                  _unref(errors).nombreCategoria
                    ? 'border-red-300 focus:border-red-500 focus:ring-2 focus:ring-red-200'
                    : 'border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200',
                ]
                                  }), null, 16), [
                                    [_vModelText, _unref(nombreCategoria)]
                                  ]),
                                  (_unref(errors).nombreCategoria)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                                        _cache[5] || (_cache[5] = _createElementVNode("svg", {
                                          class: "w-4 h-4 shrink-0",
                                          fill: "currentColor",
                                          viewBox: "0 0 20 20"
                                        }, [
                                          _createElementVNode("path", {
                                            "fill-rule": "evenodd",
                                            d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                            "clip-rule": "evenodd"
                                          })
                                        ], -1)),
                                        _createTextVNode(" " + _toDisplayString(_unref(errors).nombreCategoria), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(nombreCategoria).length) + "/50 caracteres ", 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block text-sm font-semibold text-slate-700 mb-2" }, " Descripción ", -1)),
                                  _withDirectives(_createElementVNode("textarea", _mergeProps({
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(descripcionCategoria) ? (descripcionCategoria).value = $event : null))
                                  }, _unref(descripcionCategoriaAttrs), {
                                    placeholder: "Describe la categoría...",
                                    rows: "5",
                                    maxlength: "200",
                                    class: [
                  'w-full px-4 py-3 border-2 rounded-xl transition-all outline-none resize-none',
                  _unref(errors).descripcionCategoria
                    ? 'border-red-300 focus:border-red-500 focus:ring-2 focus:ring-red-200'
                    : 'border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200',
                ]
                                  }), null, 16), [
                                    [_vModelText, _unref(descripcionCategoria)]
                                  ]),
                                  (_unref(errors).descripcionCategoria)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                        _cache[7] || (_cache[7] = _createElementVNode("svg", {
                                          class: "w-4 h-4 shrink-0",
                                          fill: "currentColor",
                                          viewBox: "0 0 20 20"
                                        }, [
                                          _createElementVNode("path", {
                                            "fill-rule": "evenodd",
                                            d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                            "clip-rule": "evenodd"
                                          })
                                        ], -1)),
                                        _createTextVNode(" " + _toDisplayString(_unref(errors).descripcionCategoria), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(descripcionCategoria).length) + "/200 caracteres ", 1)
                                ])
                              ]))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})